import CloseIcon from "../../assets/img/closeIcon.svg";
import Cancelimg from "../../assets/img/cancel-01.svg";
import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatPropertyAddress,
  haveValue,
  shouldShowCapacityReport,
} from "../../helper/common";
import ConfirmRemovalModal from "./ConfirmRemovalModal";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";
import AuthContext from "../../context/auth/AuthContext";

const ShareWorkspaceModal = ({
  isOpen,
  onClose,
  wholeData: wholeDataMain,
  dataType,
  refreshFunc,
  isFromTenantProfile,
}) => {
  const { _t } = useTranslator();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { workspaceId } = useParams();

  const [searchText, setSearchText] = useState("");
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectAllSelected, setSelectAllSelected] = useState(false);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [confirmPopupType, setConfirmPopupType] = useState("");
  const [wholeData, setWholeData] = useState([]);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  const handleOpenCapacityReport = () => {
    if (selectedFields?.length === 0) return;
    const params = new URLSearchParams();
    selectedFields.forEach((f) =>
      params.append("sharedprofileid", f.share_profile_id)
    );
    const base = workspaceId ? `/${workspaceId}` : "";
    window.open(
      `${base}/capacity-report?${params.toString()}`,
      "_blank",
      "noreferrer"
    );
  };

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  const loopVals = useMemo(() => {
    if (!haveValue(searchText)) return wholeData;

    const searchLower = searchText.toLowerCase();
    // #NOTEL for application, we have participants, so we need to filter by participant's email or name
    return wholeData.filter((item) => {
      const participants = item?.application?.participants ?? [];
      // search by participant's email OR participant's name
      if (participants.length > 0) {
        return participants.some(
          (p) =>
            p?.email?.toLowerCase().includes(searchLower) ||
            p?.name?.toLowerCase().includes(searchLower) ||
            item?.label?.toLowerCase().includes(searchLower) ||
            item?.sub_val?.toLowerCase().includes(searchLower)
        );
      }
      return (
        item?.label?.toLowerCase().includes(searchLower) ||
        item?.sub_val?.toLowerCase().includes(searchLower)
      );
    });
  }, [wholeData, searchText]);

  useEffect(() => {
    if (dataType == "properties") {
      setWholeData(
        wholeDataMain?.map((val) => ({
          label: formatPropertyAddress(val, currentLang),
          value: val?._id,
        }))
      );
    } else {
      setWholeData(wholeDataMain);
    }
  }, [wholeDataMain]);

  const handleCheckboxChange = (selectedData) => (e) => {
    const isChecked = e.target.checked;

    setSelectedFields((prev) => {
      let updated;

      if (isChecked) {
        updated = [...prev, selectedData];
      } else {
        updated = prev.filter((val) => val.value !== selectedData.value);
      }

      // 🔑 update selectAllSelected based on counts
      setSelectAllSelected(updated.length === wholeData.length);

      return updated;
    });
  };

  const handleSelectAll = () => {
    setSelectAllSelected((prev) => {
      if (prev) {
        setSelectedFields([]);
      } else {
        setSelectedFields(wholeData);
      }
      return !prev;
    });
  };

  const handleUnSelectAll = () => {
    setSelectedFields([]);
    setSelectAllSelected(false);
  };

  const handleCloseConfirmation = () => {
    setConfirmationPopup(false);
  };

  return (
    <>
      {isOpen && !confirmationPopup && (
        <div className="wrapper-modal" onClick={onClose}>
          <div
            className={`doc-history-popup total-salary-modal share-profile-modal share-workspace-modal  ${
              isOpen ? "open" : ""
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <span className="drawerIcon" onClick={onClose} />
            <div>
              <div className="doc-history-header">
                <div className="d-flex align-items-center custom-gap-2">
                  <img
                    src={CloseIcon}
                    alt=""
                    className="doc-history-close-btn"
                    onClick={onClose}
                  />
                  <h4 className="custom-modal-heading">
                    {/* {_t("shareToWorkspaces")} */}
                    {_t(
                      isFromTenantProfile ? "manageTenants" : "manageProperties"
                    )}
                  </h4>
                </div>
              </div>
            </div>
            <div className="listWrapper">
              <div className="tabs-box-pattern">
                <div className="tabs-item d-flex flex-column">
                  <div className="profile-page marless tab-profile-search-header">
                    <div className="Search-bar searchbar_cls">
                      <div className="search_bar_edit">
                        <a href="#">
                          <img src={"/images/search-icon-grey.svg"} alt="" />
                        </a>
                        <input
                          type="text"
                          className="custom-input mb-0 input01"
                          placeholder={
                            dataType == "properties"
                              ? _t("searchProperties")
                              : _t("searchTenants")
                          }
                          value={searchText}
                          onChange={(e) => {
                            setSearchText(e.target.value);
                          }}
                        />
                        {haveValue(searchText) ? (
                          <img
                            src={Cancelimg}
                            alt="icon"
                            onClick={() => {
                              setSearchText("");
                            }}
                            className="canceicon topRightIcon searchCrossIcon"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`Notifications-row notificationRow ${dataType === "tenants" ? "tenantRow" : ""}`}
                  >
                    {!haveValue(searchText) && (
                      <div className="d-flex items-center Notifications-wapper notificationsWrapper opacity-wapper px-0 tt justify-content-between">
                        <div className="mobile-profile-info-box">
                          {/* <div
                            className={`checkboxWrapper d-flex align-items-center justify-content-center`}
                          >
                            <label className="custom-gap-3 custom-checkbox mb-0">
                              <input
                                type={`checkbox`}
                                checked={selectAllSelected}
                                onClick={handleSelectAll}
                              />
                              <span className={`custom-checkmark`}></span>
                            </label>
                          </div> */}
                          <div
                            className="select-all-bg cursor-pointer d-flex align-items-center justify-content-center"
                            onClick={handleSelectAll}
                          >
                            {selectedFields?.length === loopVals?.length ? (
                              <span className="checkmark-icon-all" />
                            ) : (
                              <span className="select-border" />
                            )}
                          </div>
                          <div className="userDetails cursor-pointer">
                            <h4>
                              {selectedFields?.length === loopVals?.length
                                ? _t("allSelected")
                                : `${selectedFields?.length || 0} ${_t("of")} ${loopVals?.length || 0} ${_t("selected")}`}
                            </h4>
                          </div>
                          {dataType !== "properties" && (
                            <div
                              data-tooltip-id="button-action-tooltip"
                              style={{ display: "inline-block" }}
                            >
                              <div
                                onClick={(e) => {
                                  if (selectedFields?.length === 0) return;
                                  setConfirmationPopup(true);
                                  setConfirmPopupType("remove");
                                }}
                                className={`${selectedFields?.length === 0 ? "cursor-not-allowed" : "cursor-pointer"}`}
                              >
                                <img
                                  src="/images/delete-icon.svg"
                                  alt="Delete"
                                  className="del-icon"
                                  style={{
                                    opacity:
                                      selectedFields?.length === 0 ? 0.5 : 1,
                                  }}
                                />
                              </div>
                              {selectedFields?.length === 0 && (
                                <ButtonActionTooltip />
                              )}
                            </div>
                          )}
                        </div>
                        <a
                          data-tooltip-id="button-action-tooltip"
                          className={`unSelectAll ${
                            selectedFields?.length > 0 ? "dark-green-text" : ""
                          }`}
                          onClick={handleUnSelectAll}
                        >
                          {_t("unselectAll")}
                        </a>
                        {selectedFields?.length < 0 && <ButtonActionTooltip />}
                      </div>
                    )}
                    {loopVals?.length > 0 ? (
                      loopVals?.map((vals) => (
                        <div className="Notifications-wapper notificationsWrapper opacity-wapper px-0 tt">
                          <div className="mobile-profile-info-box">
                            <div
                              className={`checkboxWrapper d-flex align-items-center justify-content-center`}
                            >
                              <label className="custom-gap-3 custom-checkbox mb-0">
                                <input
                                  type={`checkbox`}
                                  checked={selectedFields.some(
                                    (item) => item.value === vals?.value
                                  )}
                                  onChange={handleCheckboxChange(vals)}
                                />
                                <span className={`custom-checkmark`}></span>
                              </label>
                            </div>
                            {/* <div className="userImageWrapper">
                              <img
                                src={
                                  dataType == "properties"
                                    ? "/images/home-icon-green.svg"
                                    : UserIcon
                                }
                              />
                            </div> */}
                            {vals?.application ? (
                              <span className="position-relative">
                                <div className="userImageWrapper d-flex align-items-center justify-content-center">
                                  <img
                                    src="/images/Flatmates.svg"
                                    alt="Application Icon"
                                  />
                                </div>
                                {vals?.application?.participants?.length >
                                  0 && (
                                  <div className="member-count-wrapper d-flex align-items-center justify-content-center">
                                    {vals?.application?.participants?.length}
                                  </div>
                                )}
                              </span>
                            ) : (
                              <div className="userImageWrapper d-flex align-items-center justify-content-center">
                                <img src={UserIcon} />
                              </div>
                            )}
                            <div className="userDetails">
                              <h4>{vals?.label}</h4>
                              {haveValue(vals?.sub_val) && (
                                <p className="email-text">{vals?.sub_val}</p>
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="notSharedText text-center">
                        {_t("noDataFound")}
                      </p>
                    )}
                  </div>
                  <div
                    className={`buttonset_css d-flex align-items-center justify-content-center custom-gap-2 grid-button ${
                      !shouldShowCapacityReport(
                        user?.current_workspace,
                        user
                      ) && dataType === "tenants"
                        ? "grid-one"
                        : ""
                    }`}
                  >
                    {dataType === "properties" && (
                      <div
                        data-tooltip-id="button-action-tooltip"
                        style={{ display: "inline-block" }}
                      >
                        <button
                          type="button"
                          className="btnNext commonButtonPropertyDark commonButtonPropertyLight removeBtn removeBtnBg"
                          disabled={selectedFields?.length === 0}
                          onClick={(e) => {
                            setConfirmationPopup(true);
                            setConfirmPopupType("remove");
                          }}
                        >
                          <img src="/images/delete-icon.svg" alt="Delete" />
                          {_t("removeFromThisWorkspace")}
                        </button>
                        {selectedFields?.length === 0 && (
                          <ButtonActionTooltip />
                        )}
                      </div>
                    )}
                    <div
                      data-tooltip-id="button-action-tooltip"
                      style={{ display: "inline-block" }}
                    >
                      <button
                        type="button"
                        className="btnNext commonButtonPropertyDark removeBtn"
                        disabled={selectedFields?.length === 0}
                        onClick={(e) => {
                          setConfirmationPopup(true);
                          setConfirmPopupType("add");
                        }}
                      >
                        <img src="/images/share-icon-white.svg" alt="Share" />
                        {_t("shareWithAWorkspace")}
                      </button>
                      {selectedFields?.length === 0 && <ButtonActionTooltip />}
                    </div>
                    {dataType !== "properties" &&
                      shouldShowCapacityReport(
                        user?.current_workspace,
                        user
                      ) && (
                        <div
                          data-tooltip-id="button-action-tooltip"
                          style={{ display: "inline-block" }}
                        >
                          <button
                            type="button"
                            className="btnNext commonButtonPropertyDark removeBtn"
                            disabled={selectedFields?.length === 0}
                            onClick={handleOpenCapacityReport}
                          >
                            <img
                              src="/images/view-details-green.svg"
                              alt="Share"
                            />
                            {_t("capacityReport")}
                          </button>
                          {selectedFields?.length === 0 && (
                            <ButtonActionTooltip />
                          )}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {confirmationPopup && (
        <ConfirmRemovalModal
          confirmPopupType={confirmPopupType}
          selectedFields={selectedFields}
          onClose={handleCloseConfirmation}
          dataType={dataType}
          onCloseMain={onClose}
          refreshFunc={refreshFunc}
        />
      )}
    </>
  );
};

export default ShareWorkspaceModal;
